import Calendar from "@/utils/calendar";

const singleProductTypes = ["多品", "单品"];
const deliveryStatusList = {
  0: "待处理",
  1: "拣货中",
  2: "打标中",
  3: "打包中",
  4: "打包完成",
  5: "已发货",
  10: "已取消",
};
const addressType = {
  0: "收件人地址",
  1: "英文收货地址",
  2: "英文清关地址",
  3: "发件人地址"
};
export const columns = [
  {
    title: "收货国家",
    dataIndex: "receivingNationName",
    key: "receivingNationName",
    rowKey: "key",
  },
  {
    title: "客户名称",
    dataIndex: "customerName",
    key: "customerName",
    rowKey: "key",
  },
  {
    title: "店铺名称",
    dataIndex: "customerShopName",
    key: "customerShopName",
    rowKey: "key",
    ellipsis: true,
  },
  {
    title: "发货数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    rowKey: "key",
    width: 100,
    customRender: (text, record, index) => {
      return text + "件";
    },
  },
  {
    title: "创建时间",
    key: "createTime",
    dataIndex: "createTime",
    rowKey: "key",
    width: 200,
  },
  {
    title: "原货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    width: 280,
    rowKey: "key",
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
];

export const columns_fixed = [
  {
    title: "发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
    width: 300,
    rowKey: "key",
    fixed: "left",
    scopedSlots: {
      customRender: "deliveryTaskCode",
    },
  }
]

export const columns_fixed_smallBag = [
  {
    title: "订单编号",
    dataIndex: "platformOrderNo",
    key: "platformOrderNo",
    width: 300,
    rowKey: "key",
    fixed: "left",
    scopedSlots: {
      customRender: "platformOrderNo",
    },
  }
]

export const columns_ToBeProcessed = [
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "key",
    width: 160,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const columns_ToBeConfirm = [
  // {
  //   title: "审核后货代公司",
  //   key: "auditIntForwarderConfigId",
  //   dataIndex: "auditIntForwarderConfigId",
  //   width:280,
  //   rowKey: "key",
  //   scopedSlots: {
  //     customRender: "auditIntForwarderConfigId",
  //   },
  // },
  {
    title: "备注",
    key: "auditRemark",
    dataIndex: "auditRemark",
  },
  {
    title: "审单人",
    key: "auditName",
    dataIndex: "auditName",
  },
  {
    title: "审单方式",
    key: "reviewMethod",
    dataIndex: "reviewMethod",
    prentType: ["smallBag"],
    customRender: (text, record, index) => {
      return ['手动审单', '自动审单'][text]
    },
  },
  {
    title: "审单时间",
    key: "auditTime",
    dataIndex: "auditTime",
  },
];

export const columns_Completed = [
  {
    title: "确认时间",
    key: "confirmTime",
    dataIndex: "confirmTime",
  },
];




export const columns_SPU = [
  {
    title: "商品图片",
    key: "productMainImg",
    dataIndex: "productMainImg",
    width: 140,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "商品标题",
    key: "productTitle",
    dataIndex: "productTitle",
  },
  {
    title: "商品SPU",
    dataIndex: "productCode",
    key: "productCode",
  },
  {
    title: "供应商",
    dataIndex: "shopName",
    key: "shopName",
    scopedSlots: {
      customRender: "shopName",
    },
  },
  {
    title: "运输属性",
    dataIndex: "productTransportationAttrDTOS",
    key: "productTransportationAttrDTOS",
    scopedSlots: {
      customRender: "productTransportationAttrDTOS",
    },
  },
  {
    title: "商品数量",
    dataIndex: "totalSpuNums",
    key: "totalSpuNums",
    scopedSlots: {
      customRender: "totalSpuNums",
    },
  },
  {
    title: "异常原因",
    dataIndex: "reason",
    key: "reason",
    scopedSlots: {
      customRender: "reason",
    },
  },
  {
    title: "建议货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    width: 280,
    rowKey: "key",
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
]




export const columnsSon = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    fixed: "left",
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "商品图片",
    key: "productImg",
    dataIndex: "productImg",
    width: 140,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "商品中文名",
    key: "productName",
    dataIndex: "productName",
    scopedSlots: {
      customRender: "productName",
    },
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
    scopedSlots: {
      customRender: "shopProductSku",
    },
    width: 180
  },
  {
    title: "平台SKU",
    dataIndex: "productSku",
    key: "productSku",
    scopedSlots: {
      customRender: "productSku",
    },
  },
  {
    title: "商品规格",
    dataIndex: "productPropertiesName",
    key: "productPropertiesName",
    customRender: (text, record, index) => {
      return text || '-';
    },
  },
  {
    title: "申报品名",
    dataIndex: "productCategoryName",
    key: "productCategoryName",
    width: 140,
    customRender: (text, record, index) => {
      return text || '-';
    },
  },
  {
    title: "编制方式和材质",
    dataIndex: "compilationMethod",
    key: "compilationMethod",
    width: 140,
    customRender: (text, record, index) => {
      return text || '-';
    },
  },
  {
    title: "申报价格",
    dataIndex: "productPriceCn",
    key: "productPriceCn",
    width: 180,
    scopedSlots: {
      customRender: "productPriceCn",
    },
  },
  {
    title: "报关编码",
    dataIndex: "productDeclarationCode",
    key: "productDeclarationCode",
    width: 140,
    customRender: (text, record, index) => {
      return text || '-';
    },
  },
  {
    title: "商品数量",
    dataIndex: "deliveryNums",
    key: "deliveryNums",
    width: 140,
  },
  {
    title: "商品运输属性",
    dataIndex: "productTransportationAttrDTOS",
    key: "productTransportationAttrDTOS",
    scopedSlots: {
      customRender: "productTransportationAttrDTOS",
    },
    width: 300
  },
  {
    title: "异常原因",
    dataIndex: "reason",
    key: "reason",
    width: 180,
    fixed: "right",
    scopedSlots: {
      customRender: "reason",
    },
  },
  {
    title: "建议货代公司",
    key: "logisticsConfig",
    dataIndex: "logisticsConfig",
    width: 180,
    rowKey: "key",
    fixed: "right",
    scopedSlots: {
      customRender: "logisticsConfig",
    },
  },
];

export const columnsSon_ToBeProcessed = [
  {
    title: "操作",
    key: "action",
    dataIndex: "deliveryTaskDetailId",
    width: 140,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];


export const columnsSon_warning = [
  {
    title: "备注",
    key: "auditRemark",
    dataIndex: "auditRemark",
    width: 140,
    fixed: "right",
    scopedSlots: {
      customRender: "remark",
    },
  },
];

export const columns_warning = [
  {
    title: "提交人",
    key: "abnormalSubmitter",
    dataIndex: "abnormalSubmitter",
    rowKey: "key",
    width: 180,
  },
];

export const columnsSon_ToBeConfirm = [
  {
    title: "是否取消",
    dataIndex: "status",
    key: "status",
    width: 100,
    fixed: "right",
    customRender: (text, record, index) => {
      return text == 1 ? '是' : '否';
    },
  },
]

export const columnsSon_Completed = [
  {
    title: "确认类型",
    key: "confirmType",
    dataIndex: "confirmType",
    fixed: "right",
    width: 200,
    customRender: (text, record, index) => {
      return { 0: "-", 1: "使用建议货代公司", 2: "取消发货", 3: '按原货代公司发货' }[text];
    },
  },
];


export const reasonList = [
  {
    zh: '涉及药事法',
    ja: '麻薬、医薬品、医薬部外品、医療器具',
    id: 1
  }, {
    zh: '涉及食品法',
    ja: '食品関連',
    id: 2
  }, {
    zh: '带电池',
    ja: '電池及び電池が装着されている商品',
    id: 3
  }, {
    zh: '木制品',
    ja: '木製品',
    id: 4
  }, {
    zh: '侵权产品',
    ja: '特許権、実用新案権、意匠権、商標権、著作権、著作隣接権、育成者権を侵害する物品',
    id: 5
  }, {
    zh: '粉末，液体，以及易燃易爆物品',
    ja: '粉末、液体、可燃性物質',
    id: 6
  }, {
    zh: '武器配件，管制刀具等',
    ja: 'けん銃、小銃、機関銃、砲、これらの銃砲弾及びけん銃部品',
    id: 7
  }, {
    zh: '动植物产品',
    ja: '動植物関連',
    id: 8
  }, {
    zh: '不满足发货重量要求',
    ja: '配送用の重量要件が満たされていません',
    id: 9
  }, {
    zh: '价格过高',
    ja: 'ご指定の運送会社の運賃が高すぎ、より安い運賃の運送会社を変更します。',
    id: 10
  }
]

export const combinationColumns = [
  {
    title: "商品图片",
    key: "productImg",
    dataIndex: "productImg",
    width: 120,
    scopedSlots: {
      customRender: "productImg",
    },
  },
  {
    title: "商品标题",
    key: "productName",
    dataIndex: "productName",
  },
  {
    title: "商品规格",
    key: "productPropertiesName",
    dataIndex: "productPropertiesName",
  },
  {
    title: "平台SKU",
    key: "productSku",
    dataIndex: "productSku",
    scopedSlots: {
      customRender: "productSku",
    },
  },
  {
    title: "申报品名",
    dataIndex: "productCategoryName",
    key: "productCategoryName",
    width: 100,
  },
  {
    title: "编制方式和材质",
    dataIndex: "compilationMethod",
    key: "compilationMethod",
    width: 100,
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width: 150,
    fixed: 'right',
    scopedSlots: {
      customRender: "action",
    },
  }
]

export const combineColumns = [
  {
    title: "商品图片",
    key: "productImg",
    dataIndex: "productImg",
    width: 120,
    scopedSlots: {
      customRender: "productImg",
    },
  },
  {
    title: "商品标题",
    key: "productTitle",
    dataIndex: "productTitle",
  },
  {
    title: "商品规格",
    key: "productProp",
    dataIndex: "productProp",
  },
  {
    title: "平台SKU",
    key: "shopProductSku",
    dataIndex: "shopProductSku",
  },
  {
    title: "申报品名",
    dataIndex: "productCategoryName",
    key: "productCategoryName",
    customRender: (text, record, index) => {
      return text || '-';
    },
  },
  {
    title: "编制方式和材质",
    dataIndex: "compilationMethod",
    key: "compilationMethod",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width: 100,
    fixed: 'right'
  },
]